import { render, staticRenderFns } from "./reCapcha.vue?vue&type=template&id=a8aa8ba6&"
import script from "./reCapcha.vue?vue&type=script&lang=js&"
export * from "./reCapcha.vue?vue&type=script&lang=js&"
import style0 from "./reCapcha.vue?vue&type=style&index=0&id=a8aa8ba6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports